export default __webpack_public_path__ + "static/media/CRM - Inner page.0fb87007.png";